import React, { useState } from 'react';
import { useNavigate } from "react-router";
import AuthBanner from './AuthBanner';
import { apiService } from '../services/apiService';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};
    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Invalid email address";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        // Simulate API call for password reset
          const response = await apiService("auth/forgot-password", "POST", { email });
             
        console.log("Password reset email sent to:", email);
        console.log("Response:", response);
        navigate("/login",{
          state: { successMessage: response.message },
        }); // Navigate back to login after success
      } catch (err) {
        console.error("Error sending password reset email:", err);
        setServerError(err.message || "Failed to send password reset email. Please try again.");
      }
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Left Section (Banner + Text) */}
      <AuthBanner />

      {/* Right Section (Forgot Password Form) */}
      <div className="md:w-1/3 w-full flex items-center justify-center bg-white">
        <div className="w-full max-w-sm p-6 flex flex-col justify-between min-h-[500px]">
          <div>
            <div className="flex justify-between mb-4">
              <div className="text-3xl font-bold text-red-600">TOSHIBA</div>
            </div>

            <h2 className="text-2xl font-semibold text-[#000] mb-6">Forgot Password ?</h2>
            {serverError && (
              <div className="mb-4 text-red-500 text-sm text-center">
                {serverError}
              </div>
            )}
            <form onSubmit={handleSubmit} className="flex flex-col">
              <div className="mb-4">
                <label htmlFor="email" className="block text-sm text-[#000] pb-1">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter Email Address"
                  className={`w-full p-2 border border-[#6E757C] rounded-sm ${
                    errors.email ? "border-red-500" : "border-[#6E757C]"
                  }`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              
              </div>
              {errors.email && (
                  <p className="text-red-500 text-xs ">{errors.email}</p>
                )}
              <div className="text-right mb-4">
                <a
                  href="/login"
                  className="text-sm text-[#000] hover:text-[#000] cursor-pointer underline"
                >
                  Back To Login
                </a>
              </div>

              <div className="flex items-center justify-between mb-2">
                <button
                  type="submit"
                  className="bg-[#3D3D3D] text-white py-2 px-6 rounded-sm w-full"
                >
                  <span className="text-white text-sm cursor-pointer">Submit</span>
                </button>
              </div>
            </form>
          </div>

          <div className="text-xs text-[#000] mt-6 text-center">
            Powered by Sparsh Communications Pvt. Ltd.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;